import { createAction } from 'redux-actions';

export const getMegaMenu: any = createAction('header/GET_MEGA_MENU');
